function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { setup, assign, fromPromise } from 'xstate';
// --- Machine Setup ---
export var chatMachine = setup({
    types: {
        context: {},
        events: {},
        input: {}
    },
    actors: {
        submitPromptActor: fromPromise(/*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(param) {
                var input, prompt, submitFn, response;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            input = param.input;
                            prompt = input.prompt, submitFn = input.submitFn;
                            if (!submitFn) {
                                throw new Error('Backend submit function (backendSubmitFn) not provided.');
                            }
                            console.log('[chatMachine/submitPromptActor] Submitting prompt: "'.concat(prompt, '"'));
                            return [
                                4,
                                submitFn(prompt, {
                                    _raw: true
                                })
                            ];
                        case 1:
                            response = _state.sent();
                            console.log('[chatMachine/submitPromptActor] Submission response:', response);
                            // What does submitPrompt resolve with? Need to adjust _API_SUCCESS payload.
                            // For now, just pass the response.
                            return [
                                2,
                                response
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }())
    },
    actions: {
        assignSubmitting: assign({
            isLoading: true,
            errorMessage: null,
            currentPrompt: function(param) {
                var event = param.event;
                return event.type === 'SUBMIT_PROMPT' ? event.payload.prompt : null;
            },
            currentResponseId: null,
            currentResponseContent: ''
        }),
        assignStreamingStart: assign(function(contextAndEvent) {
            // Assuming the chat:start event logic (setting ID) will happen
            // externally and potentially trigger an event here later.
            // For now, just mark as not loading.
            console.log('[chatMachine] Streaming potentially starting (based on API success)');
            return {
            };
        }),
        assignError: assign({
            isLoading: false,
            errorMessage: function(param) {
                var event = param.event;
                if (event.type === '_API_ERROR') return event.error;
                return 'An unknown error occurred.';
            }
        }),
        assignChunk: assign({
            // Set isLoading to false only on the first chunk
            isLoading: function(param) {
                var context = param.context, event = param.event;
                if (event.type === 'RECEIVE_CHUNK' && context.currentResponseContent === '') {
                    console.log('[chatMachine] First chunk received, setting isLoading to false.');
                    return false;
                }
                return context.isLoading; // Keep current state otherwise
            },
            currentResponseContent: function(param) {
                var context = param.context, event = param.event;
                if (event.type === 'RECEIVE_CHUNK') {
                    return context.currentResponseContent + event.payload.content;
                }
                return context.currentResponseContent;
            },
            currentResponseId: function(param) {
                var context = param.context, event = param.event;
                if (event.type === 'RECEIVE_CHUNK' && context.currentResponseId === null) {
                    return event.payload.id;
                }
                return context.currentResponseId;
            }
        }),
        assignStreamFinished: assign({
            currentPrompt: null,
            isLoading: false // Ensure loading is false when finished
        }),
        resetContext: assign({
            currentPrompt: null,
            currentResponseId: null,
            currentResponseContent: '',
            errorMessage: null,
            isLoading: false
        })
    },
    guards: {}
}).createMachine({
    id: 'chatMachine',
    initial: 'idle',
    context: function(param) {
        var input = param.input;
        return {
            currentPrompt: null,
            currentResponseId: null,
            currentResponseContent: '',
            errorMessage: null,
            isLoading: false,
            backendSubmitFn: input.backendSubmitFn
        };
    },
    states: {
        idle: {
            on: {
                SUBMIT_PROMPT: {
                    target: 'submitting',
                    actions: 'assignSubmitting'
                },
                RESET: {
                    actions: 'resetContext'
                }
            }
        },
        submitting: {
            invoke: {
                id: 'submitPromptActor',
                src: 'submitPromptActor',
                input: function(param) {
                    var context = param.context;
                    return {
                        prompt: context.currentPrompt,
                        submitFn: context.backendSubmitFn
                    };
                },
                onDone: {
                    // API call was accepted, likely streaming will start via external events
                    target: 'streamingResponse',
                    actions: 'assignStreamingStart'
                },
                onError: {
                    target: 'error',
                    actions: 'assignError'
                }
            },
            on: {
                // Allow reset while submitting
                RESET: {
                    target: 'idle',
                    actions: 'resetContext'
                }
            }
        },
        streamingResponse: {
            // This state primarily waits for external RECEIVE_CHUNK / FINISH_STREAM events
            on: {
                RECEIVE_CHUNK: {
                    actions: 'assignChunk'
                },
                FINISH_STREAM: {
                    target: 'idle',
                    actions: 'assignStreamFinished'
                },
                RESET: {
                    target: 'idle',
                    actions: 'resetContext'
                }
            }
        },
        error: {
            on: {
                SUBMIT_PROMPT: {
                    target: 'submitting',
                    actions: 'assignSubmitting'
                },
                RESET: {
                    target: 'idle',
                    actions: 'resetContext'
                }
            }
        }
    }
});
